module.exports = __webpack_public_path__ + "media/images/top/card-ceremony-2257c4e2ac0fedf4b626251da66e0b3a.jpg";